import { render, staticRenderFns } from "./QuantPage.vue?vue&type=template&id=46340818&scoped=true"
import script from "./QuantPage.vue?vue&type=script&lang=ts"
export * from "./QuantPage.vue?vue&type=script&lang=ts"
import style0 from "./QuantPage.scss?vue&type=style&index=0&id=46340818&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46340818",
  null
  
)

export default component.exports